import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import PublicLayout from "@/components/layout/PublicLayout";
import Home from "@/pages/Home";
import Workshops from "@/pages/Workshops";
import Themes from "@/pages/Themes";
import PrivateEvents from "@/pages/PrivateEvents";
import Corporate from "@/pages/Corporate";
import CustomRugs from "@/pages/CustomRugs";
import TuftBuddies from "@/pages/TuftBuddies";
import PatchHatBar from "@/pages/PatchHatBar";
import Community from "@/pages/Community";
import GiftCards from "@/pages/GiftCards";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import BookWorkshop from "@/pages/BookWorkshop";
import PaymentSuccess from "@/pages/PaymentSuccess";
import DynamicPage from "@/pages/DynamicPage";
import ScrollToTop from "@/components/ScrollToTop";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Policies from "@/pages/Policies";

function App() {
  return (
    <AuthProvider>
      <ContentProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/workshops" element={<Workshops />} />
            <Route path="/themes" element={<Themes />} />
            <Route path="/workshops/:id" element={<BookWorkshop />} />
            <Route path="/private-events" element={<PrivateEvents />} />
            <Route path="/corporate" element={<Corporate />} />
            <Route path="/custom-rugs" element={<CustomRugs />} />
            <Route path="/tuft-buddies" element={<TuftBuddies />} />
            <Route path="/patch-hat-bar" element={<PatchHatBar />} />
            <Route path="/community" element={<Community />} />
            <Route path="/gift-cards" element={<GiftCards />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/policies/:slug" element={<Policies />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/p/:slug" element={<DynamicPage />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      </ContentProvider>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}
export default App;
